export default __webpack_public_path__ + "static/media/CityscapeOutline.f85ef2cc.png";